import React from 'react';

import SimpleList from 'components/shared/SimpleList/SimpleList';

import './BankAccountDetails.scss';

const BankAccountDetails = ({
  bankAccountDetails: { accountOwners, bankAgreementKey }
}) => {
  const { lastFour, routingNumber, nonTokenAccountNumber } = bankAgreementKey || {};
  return (
    <div className="bank-details">
      <div className="bank-owners bank-details-col blocked_data">
        <h3>account owner</h3>
        <SimpleList itemsList={accountOwners} />
      </div>
      <div className="bank-routing-number bank-details-col blocked_data">
        <h3>routing number</h3>
        <SimpleList itemsList={[routingNumber]} />
      </div>
      <div className="bank-account-number bank-details-col blocked_data">
        <h3>account number</h3>
          {nonTokenAccountNumber ? (<SimpleList itemsList={[`XXXXX${nonTokenAccountNumber}`]} />)
              :(<SimpleList itemsList={[`XXXXX${lastFour}`]} />)}
      </div>
    </div>
  );
};

export default BankAccountDetails;
